<template lang="pug">
#app
  router-view
  notifications(position="top right", width="200px")
  version-dialog(:show="hashChanged", @submit="reloadApp")
</template>

<script>
import { refreshPageMixin } from './mixins/refresh-page'
import VersionDialog from './components/dialog/version-dialog/index.vue'

export default {
  components: {
    VersionDialog
  },
  mixins: [refreshPageMixin],
  mounted() {
    this.initVersionCheck('/version.json')
  }
}
</script>

<style lang="stylus">
html {
  overscroll-behavior: none;
}

html, body, #app {
  font-family: $main-font !important;
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #101412;
  background: url('./assets/images/bg.jpg') no-repeat;
  background-size: cover;
}

.v-content {
  flex: inherit !important;
}

.overflow {
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.notification-content {
  text-align: center;
}
.vue-notification-group {
  margin-top: 60px;
}
</style>
